
import { roleInfo } from "../../Pages/API/config";

export const meunuList = [
  {
    link: "/dashboard",
    name: "Dashboard",
    icon: "Dashboard",
    title:false,
    userID: [roleInfo.admin],
  },
  {
    link: `/report/${btoa("report")}`,
    name: "Report",
    icon: "ListAlt",
    title:false,
    userID: [roleInfo.oe,roleInfo.controller,roleInfo.admin],
  },
  {
    link: `/formlist/${btoa("admin")}`,
    name: "Admin",
    icon: "ListAlt",
    title:false,
    userID: [roleInfo.admin],
    module:"formlist"
  },
  {
    link: `/formlist/${btoa("contract staff")}`,
    name: "Contractor Staff",
    title:false,
    icon: "ListAlt",
    userID: [roleInfo.contractStaff],
    module:"formlist"
  },
  {
    link: `/formlist/${btoa("agt")}`,
    name: "AGT",
    icon: "ListAlt",
    title:false,
    userID: [roleInfo.agt],
    module:"formlist"
  },
  {
    link: `/formlist/${btoa("technician")}`,
    name: "Technician",
    icon: "ListAlt",
    title:false,
    userID: [roleInfo.technican],
    module:"formlist"
  },
  {
    link: `/formlist/${btoa("sme approver")}`,
    name: "SME",
    title:false,
    icon: "ListAlt",
    userID: [roleInfo.sme],
    module:"formlist"
  },
  {
    link: `/formlist/${btoa("engineer")}`,
    name: "Engineer",
    title:false,
    icon: "ListAlt",
    userID: [roleInfo.engineer],
    module:"formlist"
  },
  {
    link: `/formlist/${btoa("operation manager")}`,
    name: "Operation Manager",
    title:false,
    icon: "ListAlt",
    userID: [roleInfo.operationManager],
    module:"formlist"
  },
  {
    link: `/formlist/${btoa("hsse verifier")}`,
    name: "HSSE",
    title:false,
    icon: "ListAlt",
    userID: [roleInfo.HSSE],
    module:"formlist"
  },
  {
    link: `/formlist/${btoa("permit issuer")}`,
    name: "Permit Issuer",
    icon: "ListAlt",
    title:false,
    userID: [roleInfo.pi],
    module:"formlist"
  },
  {
    link: `/formlist/${btoa("lifting inspector")}`,
    name: "Lifting Inspector",
    icon: "ListAlt",
    title:false,
    userID: [roleInfo.liftingInspector],
    module:"formlist"
  },
  {
    link: `/formlist/${btoa("lead permit issuer")}`,
    name: "Lead Permit Issuer",
    icon: "ListAlt",
    title:false,
    userID: [roleInfo.lpi],
    module:"formlist"
  },
   {
    link: `/formlist/${btoa("isolation owner")}`,
    name: "Isolation Owner",
    icon: "ListAlt",
    title:false,
    userID: [roleInfo.isolationOwner],
    module:"formlist"
  },
  {
    link: `/formlist/${btoa("isolation verifier")}`,
    name: "Isolation Verifier",
    icon: "ListAlt",
    title:false,
    userID: [roleInfo.isolationVerifier],
    module:"formlist"
  },
 {
    link: `/formlist/${btoa("oe")}`,
    name: "OE",
    icon: "ListAlt",
    title:false,
    userID: [roleInfo.oe],
    module:"formlist"
  },
  {
    link: `/formlist/${btoa("controller")}`,
    name: "Controller",
    icon: "ListAlt",
    title:false,
    userID: [roleInfo.controller],
    module:"formlist"
  },
  {
    link: `/activepermit`,
    name: "Active Permit",
    icon: "ListAlt",
    title:false,
    userID: [roleInfo.admin],
    pspCompany: true,
  },
  {
    name: "Setting",
    title:true,
    userID: [roleInfo.admin],
    childMenu: [
      {
        link: `/user`,
        name: "Users",
        icon: "Group",
        userID: [roleInfo.admin],
      },
      {
        link: `/terminal`,
        name: "Terminal",
        icon: "DeveloperBoard",
        userID: [roleInfo.admin],
        pspCompany: true,
      },
      {
        link: `/site`,
        name: "Site",
        icon: "PinDrop",
        userID: [roleInfo.admin],
        pspCompany: true,
      },
       {
        link: `/company`,
        name: "Company",
        icon: "Business",
        userID: [roleInfo.admin],
        pspCompany: true,
      },
      {
        link: `/emailtemplate`,
        name: "Email Template",
        icon: "Business",
        userID: [roleInfo.admin],
        pspCompany: true,
      },
      {
        link: `/eptw-report`,
        name: "e-PTW Report",
        icon: "Assessment",
        userID: [roleInfo.admin],
        pspCompany: true,
      },
    ],
  },
];
